let cleanup = null;

function init() {
  cleanup?.();
  cleanup = null;
  const root = document.getElementById('DrvStickyAtc');
  const scope = root && (root.closest('.shopify-section') || document);
  const mainAtc = scope && scope.querySelector('.drv-pdp__atc');
  if (!root || !mainAtc) return;
  const select = root.querySelector('[data-drv-satc-plan]');
  const cta = root.querySelector('[data-drv-satc-cta]');
  const radios = [...scope.querySelectorAll('.drv-pdp__plan-radio')].filter((r) => !r.disabled);
  const keyOf = (r) => r.dataset.drvKey || r.value;

  const num = scope.querySelector('.drv-pdp--rating .drv-pdp__rating-num');
  if (num && num.textContent.trim()) {
    const count = scope.querySelector('.drv-pdp--rating .drv-pdp__rating-count');
    const stars = scope.querySelector('.drv-pdp--rating .drv-pdp__stars');
    root.querySelector('.drv-satc__rating-num').textContent = num.textContent;
    root.querySelector('.drv-satc__rating-count').textContent = count ? count.textContent : '';
    if (stars) root.querySelector('.drv-pdp__stars').style.cssText = stars.style.cssText;
    root.querySelector('[data-drv-satc-rating]').hidden = false;
  }

  if (radios.length) {
    select.innerHTML = '';
    for (const r of radios) {
      const title = r.closest('label')?.querySelector('.drv-pdp__option-title');
      const label = r.dataset.drvLabel || (title ? title.textContent.trim() : select.dataset.drvSatcOnceLabel);
      select.add(new Option(label, keyOf(r)));
    }
    select.hidden = false;
  }

  const syncFromMain = () => {
    const checked = radios.find((r) => r.checked);
    if (checked) select.value = keyOf(checked);
    cta.textContent = mainAtc.textContent.replace(/\s+/g, ' ').trim();
    cta.disabled = mainAtc.disabled;
  };
  syncFromMain();

  const mo = new MutationObserver(syncFromMain);
  mo.observe(mainAtc, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true, characterData: true });

  const ac = new AbortController();
  const { signal } = ac;

  select.addEventListener(
    'change',
    () => {
      const r = radios.find((x) => keyOf(x) === select.value);
      if (r && !r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncFromMain();
    },
    { signal }
  );
  radios.forEach((r) => r.addEventListener('change', syncFromMain, { signal }));

  cta.addEventListener(
    'click',
    () => {
      mainAtc.click();
      syncFromMain();
    },
    { signal }
  );

  const io = new IntersectionObserver((entries) => {
    const e = entries[entries.length - 1];
    const show = !e.isIntersecting && e.boundingClientRect.top < 0;
    root.classList.toggle('is-visible', show);
    root.inert = !show;
  });
  io.observe(mainAtc);

  cleanup = () => {
    ac.abort();
    io.disconnect();
    mo.disconnect();
  };
}

init();
document.addEventListener('shopify:section:load', init);
document.addEventListener('drv:variant-change', init);
document.addEventListener('shopify:section:unload', (e) => {
  if (e.target.contains(document.getElementById('DrvStickyAtc'))) cleanup?.();
});
